import { render } from "./ReceivedBillRequests.vue?vue&type=template&id=69b84fad"
import script from "./ReceivedBillRequests.vue?vue&type=script&lang=js"
export * from "./ReceivedBillRequests.vue?vue&type=script&lang=js"

import "./ReceivedBillRequests.vue?vue&type=style&index=0&id=69b84fad&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__